import axios from "axios";
import { UserRole } from "../../types/domain";

export const getUserRoles = async (): Promise<UserRole[]> => {
  const response = await axios.get(`/api/role`);
  const responseDto = response.data;
  return responseDto.data as UserRole[];
};
